export default [
  {state: "Alabama", region: "SE"},
  {state: "Alaska", region: "Pacific NW"},
  {state: "Arizona", region: "Desert SW"},
  {state: "Arkansas", region: "SW"},
  {state: "California", region: "California"},
  {state: "Colorado", region: "Mountain"},
  {state: "Connecticut", region: "Eastern"},
  {state: "Delaware", region: "Eastern"},
  {state: "District of Columbia", region: "Eastern"},
  {state: "Florida", region: "SE"},
  {state: "Georgia", region: "SE"},
  {state: "Hawaii", region: "California"},
  {state: "Idaho", region: "Pacific NW"},
  {state: "Illinois", region: "Central"},
  {state: "Indiana", region: "Central"},
  {state: "Iowa", region: "Midwest"},
  {state: "Kansas", region: "Midwest"},
  {state: "Kentucky", region: "Central"},
  {state: "Louisiana", region: "SW"},
  {state: "Maine", region: "New England"},
  {state: "Maryland", region: "Eastern"},
  {state: "Massachusetts", region: "New England"},
  {state: "Michigan", region: "Central"},
  {state: "Minnesota", region: "Midwest"},
  {state: "Mississippi", region: "SE"},
  {state: "Missouri", region: "Central"},
  {state: "Montana", region: "Mountain"},
  {state: "Nebraska", region: "Midwest"},
  {state: "Nevada", region: "Desert SW"},
  {state: "New Hampshire", region: "New England"},
  {state: "New Jersey", region: "Eastern"},
  {state: "New Mexico", region: "Mountain"},
  {state: "New York", region: "Eastern"},
  {state: "North Carolina", region: "SE"},
  {state: "North Dakota", region: "Midwest"},
  {state: "Ohio", region: "Central"},
  {state: "Oklahoma", region: "SW"},
  {state: "Oregon", region: "Pacific NW"},
  {state: "Pennsylvania", region: "Eastern"},
  {state: "Rhode Island", region: "New England"},
  {state: "South Carolina", region: "SE"},
  {state: "South Dakota", region: "Midwest"},
  {state: "Tennessee", region: "SE"},
  {state: "Texas", region: "SW"},
  {state: "Utah", region: "Pacific NW"},
  {state: "Vermont", region: "New England"},
  {state: "Virginia", region: "Eastern"},
  {state: "Washington", region: "Pacific NW"},
  {state: "West Virginia", region: "Eastern"},
  {state: "Wisconsin", region: "Central"},
  {state: "Wyoming", region: "Mountain"},
  {state: "Puerto Rico", region: "Eastern"}
]
